/**
 * Empty State Component
 */

import React from 'react';

interface EmptyStateProps {
    title: string;
    message: string;
    actionLabel?: string;
    onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, actionLabel, onAction }) => {
    return (
        <div className="empty-state">
            <div className="empty-state-content">
                <h2>{title}</h2>
                <p>{message}</p>
                {actionLabel && onAction && (
                    <button className="empty-state-action" onClick={onAction}>
                        {actionLabel}
                    </button>
                )}
            </div>
        </div>
    );
};

export default EmptyState;
